<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer__copyright">
        © CryptoAlerts {{ year }}. All rights reserved.
      </div>
      <div class="footer__links">
        <router-link to="/support" class="footer__link">
          <red-text class="footer__link">Support</red-text>
        </router-link>
        <span class="footer__separator"></span>
        <router-link to="/terms-of-use" class="footer__link">
          <red-text class="footer__link">Terms of use</red-text>
        </router-link>
        <span class="footer__separator"></span>
        <router-link to="/privacy-policy" class="footer__link">
          <red-text class="footer__link">Privacy policy</red-text>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: (new Date()).getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  border: $common-border;
  background: $white-color3;
  &__copyright {
    @include font(13px, $grey-color1, 500);
    padding-left: 31px;
  }
  &__links {
    display: flex;
    margin-top: 1px;
    padding-right: 29px;
  }
  &__separator {
    background: $white-color4;
    width: 1px;
    height: 13px;
    margin: 5px 8px 0;
    position: relative;
    top: -3px;
  }
}
.footer-container {
  height: $footer-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @include container;
  max-width: 964px;
  flex-wrap: wrap;
}
.footer__link {
  text-decoration: none;
  font-weight: 500;
}
.footer_homepage {
  border-top: 1px solid $white-color5;
  position: relative;
  z-index: 2;
}

@include mobileStyles {
  .footer-container {
    justify-content: center;
    flex-direction: column;
    height: 98px;
    justify-content: space-between;
  }
  .footer__copyright {
    padding-left: 0;
    margin-top: 15px;
  }
  .footer__links {
    padding-right: 0;
    margin-bottom: 23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/FooterEl.vue